import { useQuery } from "react-query";
import {
  getAllMembershipPlans,
  getMembershipSubscription,
} from "../../../helpers/api";
import { Alert, Badge, Loader, Modal, Paper, Switch } from "@mantine/core";
import _ from "lodash";
import { RedeemBenefits } from "../../../components/billing/redeem-benefits";
import { Divider, Select, Tabs } from "antd";
import { useState } from "react";
import { RequiredIndicator } from "../../../components";
import {
  calSubscriptionEndDate,
  cedisLocale,
} from "../../../helpers/utilities";
import {
  MEMBERSHIP_CYCLES,
  MEMBERSHIP_SUBSCRIPTION_TERMS,
} from "../../../helpers/config";

export const EditMemberPlan = ({ membershipId }) => {
  const {
    data: sub,
    isError,
    isFetching,
  } = useQuery({
    queryFn: () => getMembershipSubscription(membershipId),
    queryKey: ["membership", membershipId],
  });

  const [modal, setModal] = useState({
    title: "",
    open: false,
    content: "",
    size: 500,
    zIndex: 55,
  });

  return (
    <>
      <Modal
        title={modal.title}
        opened={modal.open}
        size={modal.size}
        onClose={() => setModal({ ...modal, open: false })}
        zIndex={modal.zIndex}>
        {modal.content}
      </Modal>
      <Alert color={sub?.status === "active" ? "teal" : "red"} variant="filled">
        <h5 className="text-white m-0 d-flex justify-content-between align-items-center">
          {`${sub?.plan.planName}`}
          <Badge
            color={sub?.status === "active" ? "teal" : "red"}
            className="ms-2">
            {sub?.status === "active" ? "Active" : "InActive"}
          </Badge>
        </h5>
      </Alert>
      <Alert color={sub?.status === "active" ? "teal" : "red"} variant="light">
        <p>
          {sub?.plan.description}
          <br />
        </p>
        <div className="row">
          <div className="col-3 fw-bold">Type:</div>
          <div className="col-9">
            {_.capitalize(sub?.membershipType)} Membership
          </div>

          <div className="col-3 fw-bold">Term:</div>
          <div className="col-9">{_.capitalize(sub?.term)} Months</div>

          <div className="col-3 fw-bold">Started on:</div>
          <div className="col-9">{new Date(sub?.startDate).toDateString()}</div>

          <div className="col-3 fw-bold">Expiring on:</div>
          <div className="col-9">
            {new Date(
              calSubscriptionEndDate(sub?.term, sub?.startDate)
            ).toDateString()}
          </div>
        </div>
        {sub?.sponsor && (
          <>
            <Divider />
            <>
              <Badge color="cyan" variant="filled">
                Sponsor
              </Badge>
              <p className="h6 pt-2 pb-0 mb-0">{sub?.sponsor?.sponsorName}</p>
              <small>{sub?.sponsor?.sponsorType}</small>
            </>
          </>
        )}
        <div>
          <button
            className="button app-btn mt-3"
            onClick={() =>
              setModal({
                title: "Member Benefits",
                open: true,
                content: <RedeemBenefits planId={sub?.plan.id} />,
                size: 600,
              })
            }>
            see benefits
          </button>
        </div>
      </Alert>
    </>
  );
};

export const AddMemberPlan = ({ onUpdate, data }) => {
  const { Option } = Select;

  const { data: plans, isFetching } = useQuery({
    queryFn: () => getAllMembershipPlans(),
    queryKey: ["plans"],
  });

  return (
    <>
      {isFetching && (
        <Loader shadow="xs" padding="lg" className="text-center">
          Loading...
        </Loader>
      )}
      <h5>Subscribe Member to a Plan</h5>
      <Divider />
      <div className="row">
        <div className="col-md-7">
          <div className="field col-12">
            <label className="mb-0" htmlFor="plan">
              Select Plan
              <RequiredIndicator />
            </label>
            <Select
              required
              allowClear
              showSearch
              value={data?.planId}
              onChange={(v) => onUpdate("planId", v)}
              size="large"
              id="plan"
              className="d-block"
              placeholder="membership plan">
              {plans?.map((plan) => (
                <Option value={plan.id}>{plan.planName}</Option>
              ))}
            </Select>
          </div>
          <div className="field col-12">
            <label className="mb-0" htmlFor="term">
              Select Term
              <RequiredIndicator />
            </label>
            <Select
              required
              allowClear
              showSearch
              value={data?.term}
              onChange={(v) => onUpdate("term", v)}
              size="large"
              id="term"
              className="d-block"
              placeholder="subscription term">
              <Option value={MEMBERSHIP_SUBSCRIPTION_TERMS.twelve}>
                Annual
              </Option>
              <Option value={MEMBERSHIP_SUBSCRIPTION_TERMS.three}>
                Quarterly
              </Option>
              {/* <Option value="monthly">Monthly</Option> */}
            </Select>
          </div>
          <div className="field col-12 mt-4">
            <Switch
              size="lg"
              label="I confirm receipt of payment"
              onLabel="Paid"
              offLabel="Not Paid"
              checked={data?.isPaid}
              onChange={(v) => onUpdate("isPaid", !data?.isPaid)}
            />
          </div>
        </div>
        {/* <div className="col-md-5">
          <Alert color="teal" title="Membership Cost" variant="light">
            {!data?.term && !data.planId ? (
              <p>Select a plan and term to view membership cost</p>
            ) : (
              <>
                <p>
                  Based on the selected plan and term, total membership cost
                  will be
                </p>
                <div className="d-flex">
                  GHS{" "}
                  <h1 className="ms-2">
                    {cedisLocale.format(
                      plans?.find((p) => p.id === data?.planId)?.price /
                        MEMBERSHIP_CYCLES(data.term)
                    )}
                  </h1>
                </div>
              </>
            )}
          </Alert>
        </div> */}
      </div>
    </>
  );
};

export const PlanManagement = ({ membershipId }) => {
  const { TabPane } = Tabs;
  return (
    <>
      <Tabs defaultActiveKey="1">
        <TabPane tab="Plan" key="1">
          <p>manage membership plan here</p>
        </TabPane>
        <TabPane tab="Dependents" key="2">
          <p>manage dependents here</p>
        </TabPane>
      </Tabs>
    </>
  );
};
